import React from "react";
import { Feed } from "../containers/feed/Feed";

export function FeedPage() {
  return <Feed/>;
}
